import React from 'react';
import './FixedArea.sass';
import vkLogo from '../../images/logo.svg';
import ShopBtn from "../ShopBtn/ShopBtn";
import TextBtn from '../TextBtn/TextBtn';
import QrCode from "../QrCode/QrCode";
import { ANDROID_APP_LINK, APPGALLERY_APP_LINK, IOS_APP_LINK, RUSTORE_APP_LINK, ANDROID_DIRECT_LINK, PLATFORM_IOS, PLATFORM_ANDROID } from '../../constants';

import IconGooglePlayRu from '../../images/google_play_badge_ru_color_40.svg';
import IconGooglePlayEn from '../../images/google_play_badge_en_color_40.svg';
import IconRuStoreRu from '../../images/rustore_badge_ru_color_40.svg';
import IconRuStoreEn from '../../images/rustore_badge_en_color_40.svg';
import IconAppleRu from '../../images/app_store_badge_ru_color_40.svg';
import IconAppleEn from '../../images/app_store_badge_en_color_40.svg';
import IconAppGalleryRu from '../../images/app_gallery_badge_ru_color_40.svg';
import IconAppGalleryEn from '../../images/app_gallery_badge_en_color_40.svg';

import data from '../../data';

const FixedArea = ({
   fixed: {title, description, qrCodeText},
   forMobile = false,
   showSendLink,
   sendMessage,
   isHuawei,
   platform,
}) => {
    const currentYear = new Date().getFullYear();
    const isIOS = platform === PLATFORM_IOS;
    const isAndroid = platform === PLATFORM_ANDROID;
    const isWeb = !isIOS && !isAndroid;

    return (
        <div
            className={`fixedArea ${forMobile ? 'fixedArea--mobile' : ''} ${!showSendLink ? 'fixedArea--withOutLink' : ''}`}
        >
            <div className="fixedArea__container">
                <div className="fixedArea__top">
                    <div className="fixedArea__logo">
                        <img src={vkLogo} alt=""/>
                    </div>
                    <h1 className="fixedArea__title">
                        { title }
                    </h1>
                    <p className="fixedArea__description" dangerouslySetInnerHTML={{__html: description}}></p>
                    <div className="fixedArea__wrap"
                        style={{marginBottom: !showSendLink ? 67 : 20}}
                    >
                       <div className="fixedArea__actions">
                            {isHuawei && (
                                <div className="fixedArea__action fixedArea__action--huawei">
                                <ShopBtn
                                    href={APPGALLERY_APP_LINK}
                                    icon={data.isEng ? IconAppGalleryEn : IconAppGalleryRu}
                                    type="huawei"
                                />
                                </div>
                            )}

                            {(isIOS || isWeb) && (
                                <div className="fixedArea__action fixedArea__action--apple">
                                <ShopBtn
                                    href={IOS_APP_LINK}
                                    icon={data.isEng ? IconAppleEn : IconAppleRu}
                                    type="apple"
                                />
                                </div>
                            )}

                            {(isAndroid || isWeb) && data.isGooglePlayAvailable && (
                                <div className="fixedArea__action fixedArea__action--google">
                                <ShopBtn
                                    href={ANDROID_APP_LINK}
                                    icon={data.isEng ? IconGooglePlayEn : IconGooglePlayRu}
                                    type="google"
                                />
                                </div>
                            )}

                            {(isAndroid || isWeb) && (
                                <div className="fixedArea__action fixedArea__action--rustore">
                                <ShopBtn
                                    href={RUSTORE_APP_LINK}
                                    icon={data.isEng ? IconRuStoreEn : IconRuStoreRu}
                                    type="rustore"
                                />
                                </div>
                            )}

                            {(isAndroid || isWeb) && !(isHuawei) && (
                                <div className="fixedArea__action fixedArea__action--huawei">
                                <ShopBtn
                                    href={APPGALLERY_APP_LINK}
                                    icon={data.isEng ? IconAppGalleryEn : IconAppGalleryRu}
                                    type="huawei"
                                />
                                </div>
                            )}

                            {isAndroid && !data.isGooglePlayAvailable && (
                                <div className="fixedArea__action fixedArea__action--directDownload">
                                <TextBtn
                                    href={ANDROID_DIRECT_LINK}
                                    text={data.fixed.directDownloadToAndroid}
                                    type="green"
                                />
                                </div>
                            )}
                            </div> 
                        <div className="fixedArea__qrCode">
                            <QrCode text={qrCodeText}/>
                        </div>
                    </div>
                    {   showSendLink &&
                        <div className="fixedArea__proposal">
                            <span>Или&nbsp;</span>
                            <a
                                href="#"
                                className="modal__link"
                                onClick={e => {
                                    e.preventDefault();
                                    sendMessage();
                                }}
                            >
                                получить ссылку сообщением на телефон
                            </a>
                        </div>
                    }
                </div>
                {
                    forMobile
                    ? (
                        <div className="fixedArea__footnote">
                            <div className="fixedArea__footnote-inner">
                                &copy;&nbsp;{currentYear}&nbsp;
                                <a href={`https://${data.hostName}/team`} className="fixedArea__vk" target="_blank" rel="noopener noreferrer">{data.fixed.team}</a>
                            </div>
                        </div>
                      )
                  : (
                      <div className="fixedArea__footer">
                          &copy;&nbsp;{currentYear}&nbsp;
                          <a href={`https://${data.hostName}/team`} className="fixedArea__vk" target="_blank" rel="noopener noreferrer">{data.fixed.team}</a>
                      </div>
                      )
                }
            </div>
        </div>
    );
};

export default FixedArea;
